import { UseMutationResult } from '@tanstack/react-query'
import { graphql } from 'src/gql'
import { MutateCreateStaffingAgencyPocMutation, MutateCreateStaffingAgencyPocMutationVariables } from 'src/gql/graphql'
import { useGraphMutation } from 'src/hooks/useGraphMutation'

const document = graphql(/* graphql */`
  mutation mutateCreateStaffingAgencyPoc($record: CreateOneStaffingAgencyPocInput!) {
    cat {
      staffingAgencyPoc {
        createOne(record: $record) {
          recordId
        }
      }
    }
  }
`)

export type UseMutateCreateStaffingAgencyPocReturn = UseMutationResult<
MutateCreateStaffingAgencyPocMutation,
unknown,
MutateCreateStaffingAgencyPocMutationVariables
>

const useMutateCreateStaffingAgencyPoc = (): UseMutateCreateStaffingAgencyPocReturn => {
  return useGraphMutation(document)
}

export { useMutateCreateStaffingAgencyPoc, document as mutateCreateStaffingAgencyPocDocument }
